import { Flex, Image } from '@chakra-ui/react';
import { FC } from 'react';
import { SocialIconType } from './socials';

export const SocialIcon: FC<SocialIconType> = ({ linkUrl, iconUrl }) => {
	return (
		<a href={linkUrl}>
			<Flex
				boxSize="33px"
				border="1px solid"
				borderColor="rgba(255, 255, 255, 0.1)"
				borderRadius="40px"
				align="center"
				justify="center"
				cursor="pointer"
				_hover={{ borderColor: 'white' }}
			>
				<Image
					maxW="16px"
					maxH="16px"
					src={iconUrl}
				/>
			</Flex>
		</a>
	);
};
